const {
    OPENYOUNG_CHORE_WIP,
    OPENYOUNG_CHORE_PENDING,
    OPENYOUNG_CHORE_APPROVED,
    OPENYOUNG_CHORE_REJECTED,
    OPENYOUNG_CHORE_EXPIRED,
    OPENYOUNG_CHORE_CANCEL
} = require('constants/index');
const { formatText } = require('core/i18n').i18n;


const choresStatus = () => {
    return [
        {
            value: OPENYOUNG_CHORE_WIP,
            label: formatText(`openYoungCardChores-status${OPENYOUNG_CHORE_WIP}`)
        },
        {
            value: OPENYOUNG_CHORE_PENDING,
            label: formatText(`openYoungCardChores-status${OPENYOUNG_CHORE_PENDING}`)
        },
        {
            value: OPENYOUNG_CHORE_APPROVED,
            label: formatText(`openYoungCardChores-status${OPENYOUNG_CHORE_APPROVED}`)
        },
        {
            value: OPENYOUNG_CHORE_REJECTED,
            label: formatText(`openYoungCardChores-status${OPENYOUNG_CHORE_REJECTED}`)
        },
        {
            value: OPENYOUNG_CHORE_EXPIRED,
            label: formatText(`openYoungCardChores-status${OPENYOUNG_CHORE_EXPIRED}`)
        },
        {
            value: OPENYOUNG_CHORE_CANCEL,
            label: formatText(`openYoungCardChores-status${OPENYOUNG_CHORE_CANCEL}`)
        }
    ]
}

module.exports = {
    choresStatus,
    CUSTOM_TASK_ID: '11'
};
